__webpack_require__.p = "/kiminted-components/";